import(/* webpackMode: "eager" */ "/codebuild/output/src3540466806/src/coign-site/src/app/disclosures/page.tsx");
